import Firebase from 'firebase/app'
import credentials from './credentials'

console.log(JSON.stringify(credentials))
console.log(process.env.VUE_APP_FB_APP_ID)
export const firebaseApp = Firebase.initializeApp(credentials.firebase)